import { EthereumStakingValidatorInfo } from '#/data/react-query/queries/order-list';
import { Translation } from 'intl-lib';
// import { ReactComponent as DepositIcon } from '../images/actions/deposit.svg';
import { ValidatorRow } from './validator';

type Props = {
  validators?: EthereumStakingValidatorInfo[];
};

export function ValidatorsTable({ validators }: Props) {
  return (
    <div role="table" className="group/table flex flex-col text-sm">
      <div
        role="rowgroup"
        className="h-12 px-4 bg-slate-200 rounded-lg font-medium text-slate-600"
      >
        <div
          role="row"
          className="grid grid-cols-10 items-center gap-2 bg-slate-200 hover:bg-slate-200 h-12"
        >
          <div role="columnheader" className="col-span-2">
            <Translation path="my_staking.order.validator_column.validator" />
          </div>
          <div role="columnheader" className="col-span-2">
            <Translation path="my_staking.order.validator_column.credential_type" />
          </div>
          <div role="columnheader">
            <Translation path="my_staking.order.validator_column.balance" />
          </div>
          <div role="columnheader" className="col-span-2">
            <Translation path="my_staking.order.validator_column.last_update" />
          </div>
          <div role="columnheader">
            <Translation path="my_staking.order.validator_column.status" />
          </div>
          <div role="columnheader" className="col-span-2 text-right">
            <Translation path="my_staking.order.validator_column.action" />
          </div>
        </div>
      </div>
      <div role="rowgroup" className="group/rowgroup px-4 flex flex-col gap-2">
        {validators?.map(item => (
          <ValidatorRow key={item.validatorId} item={item} />
        ))}
      </div>
    </div>
  );
}
